//import LocalizedStrings from 'react-localization';
import { getStrings } from '../../../../../../../../Common/Localization/commonStrings';
// -----------------------------
const localizedStrings = {
  addEmailDialog: {
    strings: {
      en: {
        addNewEmailHeading: 'Add New Email Address',
        addNewPhoneHeading: 'Add New Phone Number',
        addNewTextHeading: 'Add New Text Number',
        placeholder: "Enter email address",
        placeholder1: "Re-Enter email address",
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
        editTextHeading: 'Edit Text Messaging Preference',
        editVoiceHeading: 'Edit Voice Messaging Preference',
        textMsg: 'Text Message',
        voiceMsg: 'Voice Message',
        editVoiceNote: 'Note:  Updating this phone number will automatically update all your existing voice alert preferences for this phone number.',
        editTextNote: 'Note:  Updating this mobile number will automatically update all your existing SMS alert preferences for this mobile number.',
      }
    }
  },
  editEmailDialog: {
    strings: {
      en: {
        editEmailHeading: 'Edit Email Address Preference',
        placeholder: "Enter email address",
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
        editEmailNote: 'Note:  Updating this email address will automatically update all your existing email alert preferences for this email address.',
      }
    }
  },
  deleteDialog: {
    strings: {
      en: {
        deleteEmailHeading: 'Delete Email Address',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
        deleteSubHeading: 'You are deleting the email address:',
        deleteInfo: 'All preference currently set to this email have automatically defaulted to your account email address.',
        deletePhoneNumberHeading: 'Delete Phone Number',
        deletePhoneNumberSubHeading: 'You are deleting the phone number:',
        deletePhoneNumberInfo: 'All preferences currently set to this phone number will automatically default to your primary phone number.',
      }
    }
  },
  confirmDialog: {
    strings: {
      en: {
        confirmDeleteEmailHeading: 'Confirmation',
        btnClose: 'Close',
        confirmDeleteSubHeading: 'You are deleting the email address:',
        confirmPhoneNumberDeleteSubHeading: 'Your phone number has been deleted:',
        confirmDeleteInfo: 'All preference currently set to this email have automatically defaulted to your account email address.',
        confirmPhoneNumberDeleteInfo: 'All preferences currently set to this phone number have automatically defaulted to your account phone number.',
      }
    }
  },
  mobileText: {
    strings: {
      en: {
        emailTooltip: 'This email address is the email address registered to your SCE account. This can only be changed in your account preferences.',
        voiceTooltip: 'This voice number is the voice number registered to your SCE account. This can only be changed in your account preferences.',
        textTooltip: 'This text number is the text number registered to your SCE account. This can only be changed in your account preferences.',
        delete: 'delete',
        edit: 'edit'
      }
    }
  },

};


export const getLocalizedStrings = (componentName) => {
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, true);
  return strings;
  //return new LocalizedStrings(strings);
};